'use client';

import { type ReactElement } from 'react';
import { cn } from '@fshr/shared-react';
import Intro, { type Props as IntroProps } from './intro';
import IconList, { type Props as IconListProps } from './icon-list';
import ConversationCard, { type Props as ConversationCardProps } from './conversation-card';

export type Props = {
	intro: IntroProps;
	sectionId?: string;
	iconList?: IconListProps;
	conversationCard?: ConversationCardProps;
	className?: string;
};

export default function IntroAndConversationCard({
	intro,
	sectionId,
	iconList,
	conversationCard,
	className = '',
}: Props): ReactElement {
	return (
		<div
			id={sectionId}
			className={cn('@container', 'w-full spacing-wide-grid bg-white-sand', className)}
		>
			{/* Use the component's content-box width because Blacklight can mount it in narrow sections. */}
			<div className="flex flex-col gap-y-section-margin @min-[1100px]:grid @min-[1100px]:grid-cols-12 @min-[1100px]:items-start @min-[1100px]:gap-x-300">
				<div className="flex min-w-0 flex-col gap-y-stack-l @min-[1100px]:col-span-7">
					<Intro {...intro} />
					{iconList ? <IconList {...iconList} className="@min-[1400px]:max-w-[683px]" /> : null}
				</div>

				{conversationCard ? (
					<div className="flex w-full justify-center @min-[1100px]:col-start-9 @min-[1100px]:col-span-4 @min-[1100px]:block @min-[1100px]:shrink-0">
						<ConversationCard
							{...conversationCard}
							className={cn('max-w-none', conversationCard.className)}
						/>
					</div>
				) : null}
			</div>
		</div>
	);
}
